<template>
  <SharedLineItemProductForm :line="line" auto-save @save="save"
    :restrict-qty="!!userSettings.restrictQty"
    :restrict-product="!!userSettings.restrictProduct"
    />
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
export default {
  props: ['line'],
  computed: mapGetters(['userSettings']),
  methods: {
    ...mapActions(['updateLine']),
    async save({saving, boxSize, product}) {
      await saving(
        this.updateLine({
          line: this.line,
          boxSize,
          product
        })
      );
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/basket/LineItemProductForm.vue